/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldValidationErrorDto } from './FieldValidationErrorDto';
import {
    FieldValidationErrorDtoFromJSON,
    FieldValidationErrorDtoFromJSONTyped,
    FieldValidationErrorDtoToJSON,
    FieldValidationErrorDtoToJSONTyped,
} from './FieldValidationErrorDto';
import type { ImportRowErrorStatus } from './ImportRowErrorStatus';
import {
    ImportRowErrorStatusFromJSON,
    ImportRowErrorStatusFromJSONTyped,
    ImportRowErrorStatusToJSON,
    ImportRowErrorStatusToJSONTyped,
} from './ImportRowErrorStatus';

/**
 * 
 * @export
 * @interface ImportRowErrorDto
 */
export interface ImportRowErrorDto {
    /**
     * 
     * @type {string}
     * @memberof ImportRowErrorDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportRowErrorDto
     */
    rowIndex?: number;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof ImportRowErrorDto
     */
    rawRowData?: { [key: string]: any | null; } | null;
    /**
     * 
     * @type {Array<FieldValidationErrorDto>}
     * @memberof ImportRowErrorDto
     */
    errors?: Array<FieldValidationErrorDto> | null;
    /**
     * 
     * @type {ImportRowErrorStatus}
     * @memberof ImportRowErrorDto
     */
    status?: ImportRowErrorStatus;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof ImportRowErrorDto
     */
    correctedRowData?: { [key: string]: any | null; } | null;
    /**
     * 
     * @type {Date}
     * @memberof ImportRowErrorDto
     */
    createdAt?: Date;
}



/**
 * Check if a given object implements the ImportRowErrorDto interface.
 */
export function instanceOfImportRowErrorDto(value: object): value is ImportRowErrorDto {
    return true;
}

export function ImportRowErrorDtoFromJSON(json: any): ImportRowErrorDto {
    return ImportRowErrorDtoFromJSONTyped(json, false);
}

export function ImportRowErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportRowErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'rowIndex': json['rowIndex'] == null ? undefined : json['rowIndex'],
        'rawRowData': json['rawRowData'] == null ? undefined : json['rawRowData'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(FieldValidationErrorDtoFromJSON)),
        'status': json['status'] == null ? undefined : ImportRowErrorStatusFromJSON(json['status']),
        'correctedRowData': json['correctedRowData'] == null ? undefined : json['correctedRowData'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function ImportRowErrorDtoToJSON(json: any): ImportRowErrorDto {
    return ImportRowErrorDtoToJSONTyped(json, false);
}

export function ImportRowErrorDtoToJSONTyped(value?: ImportRowErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'rowIndex': value['rowIndex'],
        'rawRowData': value['rawRowData'],
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(FieldValidationErrorDtoToJSON)),
        'status': ImportRowErrorStatusToJSON(value['status']),
        'correctedRowData': value['correctedRowData'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

